import { AXON_BRACKET_COLOR } from "../constants";

interface Props {
  size?: number;
  className?: string;
}

export function AxonMark({ size = 20, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M5 4 L5 20 L9 20"
        stroke={AXON_BRACKET_COLOR}
        strokeWidth="2.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M13 7 L18 12 L13 17"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
